<template >
  <div class="mainView">
    <div class="header">
      <div class="back">
        <img src="../../assets/image/nav_back.png" @click="goBack">
      </div>
      <div class="nav-title">电子处方</div>
    </div>
    <div class="contentBody">
      <img class="imgView" :src="rpUrl">
    </div>
  </div>
    </template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      rpUrl: '',
      path: ''
    }
  },
  beforeMount () {
    this.init()
  },
  computed: {
    ...mapGetters(['orderDetail', 'urlParams'])
  },
  methods: {
    init () {
      const { rpUrl, path } = this.$route.query
      this.rpUrl = rpUrl
      this.path = path
      //   this.rpUrl = 'https://com-shuibei-peach-rp-cs.100cbc.com/pdfstamp/22041410032434294511329060/22041410033969647420201060.png'
    },
    goBack () {
      let backPage = ''
      if (this.path === '/specialistWait/waiting') {
        this.$router.back()
        return
      }
      switch (this.orderDetail.inquiryType) {
        case 1:
          backPage = '/consultation'
          break;
        case 2:
          backPage = '/trtcCalling'
          break;
        case 3:
          backPage = '/videoPage'
          break;
        default:
          this.$router.back()
          return
      }
      this.$router.replace({
        path: backPage,
        query: {
          ...this.urlParams
        }
      })
    }
  }
}
</script>
    <style lang="stylus" scoped>

    .mainView{
      display: flex;
      width: 100%;
      height: 100vh;
      overflow: auto;
      flex-direction: column;
      .header{
        height: 44px;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        .back {
          margin-top: 8px;
          margin-left: 8px;
          img {
            width: 24px;
          }
        }
        .nav-title {
          font-size: 14px;
          display: flex;
          justify-content: center;
          width: calc(100% - 36px);
          margin-right: 36px;
        }
      }
      .contentBody{
        padding: 10px;
        width: 100%;
        height: 100%;
      }
      .imgView{
        width: 100%;
        box-sizing: border-box;
      }

    }
    @media (max-height: 610px) {
      .mainView {
        .header {
          height: 22px;

          .back {
            margin-top: 3px;
            margin-left: 3px;

            img {
              width: 16px;
            }
          }

          .nav-title {
            font-size: 12px;
          }
        }
      }
    }
    </style>
